import './styles/global.css';
import { initI18n } from './i18n';
import { initApp } from './app';
import { bootHelp } from './help/help';
import { applyEnvDocumentChrome, loadUiConfig } from './app/envChrome';

async function bootstrap() {
  await initI18n();
  await loadUiConfig();
  applyEnvDocumentChrome();
  bootHelp();
  initApp();
}

void bootstrap();
